
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSettingsUserIec as ObiSettingsUserIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-settings-user-iec.js';
 
 
 

 
 export const ObiSettingsUserIec = createComponent({
   react: React,
   tagName: 'obi-settings-user-iec',
   elementClass: ObiSettingsUserIecElement,
   events: {
     
   }
  });
 
 